import { useQuery } from "react-query";
import axios from "infra/http";
import {
  ContasRecorrentesPdfResponse,
  ContaRecorrenteParams,
} from "../typings";

function useContasRecorrentesPdf(params: ContaRecorrenteParams) {
  return useQuery(
    `/v1/conta-recorrente/pdf`,
    async () => {
      const { data } = await axios.get<ContasRecorrentesPdfResponse>(
        `/v1/conta-recorrente/pdf`,
        {
          params,
        }
      );

      return data;
    },
    {
      enabled: false,
    }
  );
}

export default useContasRecorrentesPdf;
